/**
 * Identity fields of the DAZN account forms (setup wizard, DAZN account page): `dazn_user_agent` and `dazn_x_dazn_ua`,
 * hidden fields the user never edits. Mich 2026-10-11 (option A): a new account gets the Android TV user agent, which the
 * SERVER hands out (GET /dazn/account `identityDefaults`, one source of truth with the streams); the client holds no user
 * agent string of its own. A stored value is never rewritten; an EMPTY field takes the default when the wizard is saved.
 */

/** The account's identity strings (as stored, or as the server proposes them for a new account: `identityDefaults`). */
export interface DaznIdentityFields {
  dazn_user_agent: string;
  dazn_x_dazn_ua: string;
}

/** The identity strings the server proposes for a new account (`identityDefaults` of GET /dazn/account). */
export type DaznIdentityDefaults = DaznIdentityFields;

/**
 * Hidden identity fields of the setup wizard: the account's stored values, else the server's defaults, else empty (not
 * sent: the server applies its own default when it creates the account).
 */
export function wizardIdentityFields(
  account: { dazn_user_agent?: string | null; dazn_x_dazn_ua?: string | null } | null | undefined,
  defaults: DaznIdentityDefaults | null | undefined,
): DaznIdentityFields {
  return {
    dazn_user_agent: account?.dazn_user_agent || defaults?.dazn_user_agent || '',
    dazn_x_dazn_ua: account?.dazn_x_dazn_ua || defaults?.dazn_x_dazn_ua || '',
  };
}

/** Identity fields of an account save: a value is sent only when set (an empty one is left out and the stored value stays). */
export function identityPayload(form: { dazn_user_agent?: string; dazn_x_dazn_ua?: string }): { dazn_user_agent?: string; dazn_x_dazn_ua?: string } {
  return { dazn_user_agent: form.dazn_user_agent || undefined, dazn_x_dazn_ua: form.dazn_x_dazn_ua || undefined };
}
